module.exports = __webpack_public_path__ + "img/money.353218a2.svg";